import { FunctionComponent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { INTAKE_FORM_CARD_ON_FILE_ENABLED_KEY, saveIntakeFormCardOnFileThunk } from '@spike/marketplace-action';
import { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { useApiClientWrapper } from 'hooks';
import { RootState } from 'store';
import styles from './CardOnFile.module.scss';

interface CardOnFileProps {
    disabled?: boolean;
}

export const CardOnFile: FunctionComponent<CardOnFileProps> = ({ disabled }) => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();

    const settings = useSelector((state: RootState) => state.marketplace.marketplace.settings);
    const savedEnabled =
        settings.find(setting => setting.key === INTAKE_FORM_CARD_ON_FILE_ENABLED_KEY)?.value === SETTINGS_TRUE_VALUE;

    const [enabled, setEnabled] = useState(savedEnabled);

    const handleToggle = (checked: boolean) => {
        setEnabled(checked);
        dispatch(saveIntakeFormCardOnFileThunk(apiClientWrapper, checked));
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.title}>Card On File</h3>
                <Switch
                    checked={enabled}
                    disabled={disabled}
                    onChange={handleToggle}
                />
            </div>
            <p className={styles.description}>
                Require new clients to securely add a credit or debit card when completing their intake.
            </p>
        </div>
    );
};

export default CardOnFile;
